import styled, { keyframes } from "styled-components";

const El1 = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
`;

const El2 = keyframes`
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(24px, 0);
  }
`;

const El3 = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
  }
`;

interface EllipsisContainerProps {
  Background: string;
}

export const EllipsisContainer = styled.div<EllipsisContainerProps>`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  & > div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: ${(props) => props.Background};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
    &:nth-child(1) {
      left: 8px;
      animation: ${El1} 0.6s infinite;
    }
    &:nth-child(2) {
      left: 8px;
      animation: ${El2} 0.6s infinite;
    }
    &:nth-child(3) {
      left: 32px;
      animation: ${El2} 0.6s infinite;
    }
    &:nth-child(4) {
      left: 56px;
      animation: ${El3} 0.6s infinite;
    }
  }
`;